module.exports = __webpack_public_path__ + "static/media/PromoImage_Coins.91fa24e3.png";